import './App.css';
import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import clientone from './img/client1.jpg';
import clienttwo from './img/client2.jpg';
import clientthree from './img/client3.jpg';
import clientfour from './img/client4.jpg';
import clientfive from './img/client5.jpg';
import Logo from './img/logo.png';
import me from './img/RobOffice.jpg'
import { FaBars } from "react-icons/fa";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_x0vay7s",
        "template_aegk6ua",
        {
          name: formData.name,
          email: formData.email,
          message: formData.message
        },
        "0CeW4__RY1LdiCeQc"
      )
      .then(() => {
        alert("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to send message.");
      });
    }
  return (
    <div className="App">
      <header className="App-header">
      </header>

      <div id='navbar'>
        <h2 id="logo"><img src={Logo} alt="DM Logo" /></h2>

        <ul>
          <li><a href='#hero'>Home</a></li>
          <li><a href='#about'>About</a></li>
          <li><a href='#services'>Services</a></li>
          <li><a href='#contact'>Contact</a></li>
        </ul>

        <FaBars className="menu-btn" onClick={() => setMenuOpen(!menuOpen)} />

        {menuOpen && (
          <div className="mobile-nav">
            <a href="#hero">Home</a>
            <a href="#about">About</a>
            <a href="#services">Services</a>
            <a href="#contact">Contact</a>
          </div>
        )}
      </div>

      <div id='hero'>
        <h1>Mission Statement</h1>
        <h2>
          To enhance the quality of life by helping clients live a more active lifestyle using fitness and nutrition as part of the solution.
        </h2>
        <div id="hero-button">
          <a href="#services"><button>Read More</button></a>
          <a href="#contact"><button>Get Started</button></a>
        </div>
      </div>

      <div id='about'>
        <h1>About Robert Morgan</h1>
        <div id='about-content'>
          <img src={me} alt="Myself" />
          <div id='about-text'>
            <p>
              I learned of my pre-diabetic condition after being denied life insurance in 2008. I changed my diet a little but the diabetes progressed and in 2012, I was diagnosed with Type 2 diabetes. I was determined to reverse my condition despite the doctors telling me that it was basically impossible.
            </p>
            <p>
              I did my own research, received professional advice from Naturopaths, Dietitians, Diabetes Specialist, Endocrinologists.  Educated myself, read many books, took courses, webinars, sought coaching, became certified. I have successfully reversed my Diabetes diagnosis! It is, by far, one of my most important successes in life.
            </p>
            <p id='champion'>
              “I HAVE ALWAYS CONSIDERED MYSELF A CHAMPION!”
            </p>
          </div>
        </div>
        
        <div id='achievements'>
          <h2>Achievements</h2>
        
          <h3>Racquetball</h3>
          <p id='achievement-block'>
          <ul>
            <li>Junior 9th in National rankings</li>
            <li>Senior Ontario Champion (multiple years)</li>
          </ul>
          </p>
          <h3>Football</h3>
          <p id='achievement-block'>
          <ul>
            <li>Many championship teams including AUAA Varsity Champions at Acadia University</li>
            <li>I started my University schooling at – Bemidji State University (Minnesota)</li>
          </ul>
        </p>
        </div>
        
      </div>

      <div id='services'>
        <div id='services-text'>
          <h1>Services</h1>
          <p>
            Helping one client at a time to improve their overall health with nutrtion management and an exercise program that works. Come see how Robert can help you. No two clients have the same needs. That’s why Robert designs a unique plan that fits with each clients’ needs. Centrally located in the Niagara/Hamilton area, convenient to highway access. 
          </p>
        </div>
        <div id='cards'>
          <div id="small-card">
              <img src={clientone} alt="KB Swing" />
          </div>
          <div id="small-card">
              <img src={clienttwo} alt="TRX" />
          </div>
          <div id="small-card">
              <img src={clientthree} alt="KB Squat" />
          </div>
          
        </div>
        <div id='cards'>
          <div id="small-card">
              <img src={clientfour} alt="Bosu Plank" />
          </div>
          <div id="small-card">
              <img src={clientfive} alt="DB" />
          </div>      
        </div>
      </div>
      <div id='contact'>
        <h2>Get In Touch</h2>

        <form className="contact-form" onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            value={formData.name}
            onChange={handleChange}
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            value={formData.email}
            onChange={handleChange}
          />

          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            required
            value={formData.message}
            onChange={handleChange}
          />

          <button type="submit">Send</button>
        </form>
      </div>
      <div id='footer'>
        <h2>Hours</h2>
        <p id='hours'>
          Monday–Friday: 9:00AM–5:00PM
          Saturday & Sunday: 11:00AM–3:00PM
        </p>
        <h2>Location</h2>
        <p id='location'>
          Centrally located in the Niagara/Hamilton Area, convenient to highway access.
        </p>
        <div id="foot-icons">
          <a href="https://www.instagram.com/coachmorganpt/">
            <FaInstagram id="footer-icon" />
          </a>
          <a href="https://www.facebook.com/coachmorganpt">
            <FaFacebook id="footer-icon" />
          </a>
        </div>
      </div>

    </div>
  );
}

export default App;
